(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@flyriselink/pai-auth-api", [], factory);
	else if(typeof exports === 'object')
		exports["@flyriselink/pai-auth-api"] = factory();
	else
		root["@flyriselink/pai-auth-api"] = factory();
})(this, function() {
return 